export default "__VITE_PUBLIC_ASSET__36f2871d__"